var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgPopUpCloseIcon = function SvgPopUpCloseIcon(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 16,
    height: 16,
    fill: "none"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#748DA9",
    d: "M8.003 6.35 13.778.577l1.65 1.65-5.775 5.775 5.774 5.775-1.65 1.65L8.003 9.65l-5.775 5.774-1.65-1.65 5.775-5.774L.578 2.226l1.65-1.65z"
  })));
};
export default SvgPopUpCloseIcon;